import i18next from 'i18next';

i18next.addResources('es', 'dottedProgress', {
  profile: 'Perfil',
  preExecution: 'Pre-Ejecución',
  execution: 'Ejecución',
  completed: 'Concluido'
});

i18next.addResources('en', 'dottedProgress', {
  profile: 'Profile',
  preExecution: 'Pre-Execution',
  execution: 'Execution',
  completed: 'Completed'
});

i18next.addResources('pt', 'dottedProgress', {
  profile: 'Perfil',
  preExecution: 'Pré-Execução',
  execution: 'Execução',
  completed: 'Concluído'
});
